import React, { useContext, useMemo } from 'react';
import { ImageAndContent } from '@stereoagency/ui';
import type { ILazyBlocksImage } from '@/types';
import { useCallToActions, useMediaItems } from '@/hooks';
import { LinesContext } from '@/components/LinesContext';
import { parseHtml } from '@/utils';

type Props = {
  data: {
    image: ILazyBlocksImage
    variant: 'left' | 'right'
    accent: 'none' | 'dark' | 'light'
    label?: string
    title?: string
    content?: string
    callToActions?: number[]
    darkbackground?: boolean
    headlinevariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'h1+' | 'h2+' | 'h3s'
  }
};

export default function NvisoImageAndContent({
  data: {
    image, variant, accent, label, title, content, callToActions = [], darkbackground, headlinevariant
  },
}: Props) {
  const { enableLines } = useContext(LinesContext);
  const actions = useCallToActions(callToActions, false);
  const mediaItems = useMediaItems(useMemo(() => ([image.id]), [image]));
  const imageProp = useMemo(() => {
    const mediaItem = mediaItems.get(image.id);
    return {
      src: mediaItem?.mediaItemUrl ?? image.url ?? '',
      width: mediaItem?.mediaDetails?.width ?? 1000,
      height: mediaItem?.mediaDetails?.height ?? 800,
      sizes: '(min-width: 1200px) 600px, (min-width: 770px) 50vw, 100vw',
    };
  }, [mediaItems, image]);

  return (
    <ImageAndContent
      enableLines={enableLines}
      accent={accent}
      imagePlacement={variant}
      image={imageProp}
      content={content ? parseHtml(content) : undefined}
      label={label}
      title={title}
      callToActions={actions}
      darkbackground={darkbackground}
      headlinevariant={headlinevariant}
    />
  );
}
